export const Accordion = () => import('../../../../components/Accordion.vue' /* webpackChunkName: "components/accordion" */).then(c => wrapFunctional(c.default || c))
export const AccordionItem = () => import('../../../../components/AccordionItem.vue' /* webpackChunkName: "components/accordion-item" */).then(c => wrapFunctional(c.default || c))
export const Architecture = () => import('../../../../components/Architecture.vue' /* webpackChunkName: "components/architecture" */).then(c => wrapFunctional(c.default || c))
export const ClientsOverview = () => import('../../../../components/ClientsOverview.vue' /* webpackChunkName: "components/clients-overview" */).then(c => wrapFunctional(c.default || c))
export const Cta = () => import('../../../../components/Cta.vue' /* webpackChunkName: "components/cta" */).then(c => wrapFunctional(c.default || c))
export const CtaBanner = () => import('../../../../components/CtaBanner.vue' /* webpackChunkName: "components/cta-banner" */).then(c => wrapFunctional(c.default || c))
export const CtaContact = () => import('../../../../components/CtaContact.vue' /* webpackChunkName: "components/cta-contact" */).then(c => wrapFunctional(c.default || c))
export const Dropdown = () => import('../../../../components/Dropdown.vue' /* webpackChunkName: "components/dropdown" */).then(c => wrapFunctional(c.default || c))
export const FeaturedArchitecture = () => import('../../../../components/FeaturedArchitecture.vue' /* webpackChunkName: "components/featured-architecture" */).then(c => wrapFunctional(c.default || c))
export const FeaturedBlocks = () => import('../../../../components/FeaturedBlocks.vue' /* webpackChunkName: "components/featured-blocks" */).then(c => wrapFunctional(c.default || c))
export const FeaturedProducts = () => import('../../../../components/FeaturedProducts.vue' /* webpackChunkName: "components/featured-products" */).then(c => wrapFunctional(c.default || c))
export const FeaturesAnimation = () => import('../../../../components/FeaturesAnimation.vue' /* webpackChunkName: "components/features-animation" */).then(c => wrapFunctional(c.default || c))
export const HeroAbout = () => import('../../../../components/HeroAbout.vue' /* webpackChunkName: "components/hero-about" */).then(c => wrapFunctional(c.default || c))
export const HeroCareers = () => import('../../../../components/HeroCareers.vue' /* webpackChunkName: "components/hero-careers" */).then(c => wrapFunctional(c.default || c))
export const HeroHome = () => import('../../../../components/HeroHome.vue' /* webpackChunkName: "components/hero-home" */).then(c => wrapFunctional(c.default || c))
export const HeroPageBanner = () => import('../../../../components/HeroPageBanner.vue' /* webpackChunkName: "components/hero-page-banner" */).then(c => wrapFunctional(c.default || c))
export const Logo = () => import('../../../../components/Logo.vue' /* webpackChunkName: "components/logo" */).then(c => wrapFunctional(c.default || c))
export const Modal = () => import('../../../../components/Modal.vue' /* webpackChunkName: "components/modal" */).then(c => wrapFunctional(c.default || c))
export const Roles = () => import('../../../../components/Roles.vue' /* webpackChunkName: "components/roles" */).then(c => wrapFunctional(c.default || c))
export const Team = () => import('../../../../components/Team.vue' /* webpackChunkName: "components/team" */).then(c => wrapFunctional(c.default || c))

// nuxt/nuxt.js#8607
function wrapFunctional(options) {
  if (!options || !options.functional) {
    return options
  }

  const propKeys = Array.isArray(options.props) ? options.props : Object.keys(options.props || {})

  return {
    render(h) {
      const attrs = {}
      const props = {}

      for (const key in this.$attrs) {
        if (propKeys.includes(key)) {
          props[key] = this.$attrs[key]
        } else {
          attrs[key] = this.$attrs[key]
        }
      }

      return h(options, {
        on: this.$listeners,
        attrs,
        props,
        scopedSlots: this.$scopedSlots,
      }, this.$slots.default)
    }
  }
}
